import React from 'react'
import { Box } from '@mui/material'

import { Button } from '../../../../interaxDesignSystemComponents'

interface InviteUsersActionsBarProps {
  onClear: () => void
  onInvite: () => void
  clearDisabled: boolean
  inviteDisabled: boolean
  clearLabel: string
  inviteLabel: string
}

export const InviteUsersActionsBar: React.FC<InviteUsersActionsBarProps> = ({
  onClear,
  onInvite,
  clearDisabled,
  inviteDisabled,
  clearLabel,
  inviteLabel
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        gap: '12px',
        width: '100%',
        flexWrap: 'nowrap'
      }}
    >
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Button variant="secondary" onClick={onClear} disabled={clearDisabled} fullWidth>
          {clearLabel}
        </Button>
      </Box>
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Button variant="primary" onClick={onInvite} disabled={inviteDisabled} fullWidth>
          {inviteLabel}
        </Button>
      </Box>
    </Box>
  )
}
